import axios from 'axios'
// 创建一个 axios 实例
const service = axios.create({
	baseURL: process.env.VUE_APP_BASE_API, // 所有的请求地址前缀部分
	timeout: 60000, // 请求超时时间毫秒
	// withCredentials: true, // 异步请求携带cookie
	headers: {},
})

// 添加响应拦截器
service.interceptors.response.use(
	function (response) {
		// 2xx 范围内的状态码都会触发该函数。
		// 对响应数据做点什么
		return response.data
	},
	function (error) {
		// 超出 2xx 范围的状态码都会触发该函数。
		// 对响应错误做点什么
		console.log(error)
		return Promise.reject(error)
	}
)
export default service
